var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppliedFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_988_25108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83321 3.74033C4.37987 5.72699 6.66654 8.66699 6.66654 8.66699V12.0003C6.66654 12.7337 7.26654 13.3337 7.99987 13.3337C8.73321 13.3337 9.33321 12.7337 9.33321 12.0003V8.66699C9.33321 8.66699 11.6199 5.72699 13.1665 3.74033C13.5065 3.30033 13.1932 2.66699 12.6332 2.66699H3.35987C2.80654 2.66699 2.49321 3.30033 2.83321 3.74033Z",
    fill: "#21005D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 3,
    r: 3.5,
    fill: "#F94850",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_988_25108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedFilterIcon);
export default __webpack_public_path__ + "static/media/applied-filter-icon.d57654dffdd305570d560d74dd5d6515.svg";
export { ForwardRef as ReactComponent };